import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { GET_DIGITAL_AUTH_METHODS, GET_DIGITAL_AUTH_METHODS_ERROR, GET_DIGITAL_AUTH_METHODS_SUCCESS } from '../../actions.js';

function* getDigitalAuthMethods() {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/benefit-type/digital/auth-methods`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_DIGITAL_AUTH_METHODS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_DIGITAL_AUTH_METHODS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_DIGITAL_AUTH_METHODS_ERROR, payload: error });
  }
}

export function* watchGetDigitalAuthMethods() {
  yield takeEvery(GET_DIGITAL_AUTH_METHODS, getDigitalAuthMethods);
}

function* getDigitalAuthMethodsSaga() {
  yield all([fork(watchGetDigitalAuthMethods)]);
}

export default getDigitalAuthMethodsSaga;
